import { useQuery } from '@tanstack/react-query';

import settings from '@/data/constants';
import axios from 'axios';

export interface Doctor {
  DoctorUser: {
    first_name: string;
    last_name: string;
    email: string;
    state_id: number;
  };
  calcom_initial_consult_event: string;
  calcom_follow_up_consult_event: string;
  id: number;
  doctor_code: string;
}

export const useDoctors = () => {
  const { data } = useQuery<Doctor[]>({
    queryKey: ['listDoctors'],
    queryFn: async () => {
      const response = await axios.get(`${settings.url}/doctor?raw=true`);
      return response.data;
    }
  });

  return {
    data
  };
};
